import { useEffect, useRef } from "react";

export const useStickySchedulerChrome = (enabled: boolean) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!enabled) return;
    const container = containerRef.current;
    if (!container) return;

    const tabs = document.querySelector("#main-content ul.topbar");
    const update = () => {
   
      const toolbar = container.querySelector(".k-scheduler-toolbar");
      if (toolbar) {
        container.style.setProperty(
          "--scheduler-toolbar-height",
          `${toolbar.getBoundingClientRect().height}px`
        );
      }
      const tabsAreSticky =
        tabs && window.getComputedStyle(tabs).position === "sticky";
      container.style.setProperty(
        "--tabs-sticky-height",
        tabsAreSticky ? `${tabs.getBoundingClientRect().height}px` : "0px"
      );
    };

    update();

    const observer = new ResizeObserver(update);
    observer.observe(container);
    if (tabs) observer.observe(tabs);
    return () => observer.disconnect();
  }, [enabled]);

  return containerRef;
};
